import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import { useDispatch } from 'react-redux';
import { toggleQuickPanel } from './store/stateSlice';

function QuickPanelToggleButton(props) {
  const dispatch = useDispatch();

  return (
    <IconButton className="w-40 h-40" onClick={() => dispatch(toggleQuickPanel())} size="large">
      {props.children ?? <Icon>bookmarks</Icon>}
    </IconButton>
  );
}

export default QuickPanelToggleButton;
